import 'jquery-confirm/js/jquery-confirm.js';
import 'jquery-confirm/css/jquery-confirm.css';

export default {
    confirm: function(options){
        return $.confirm(options);
    }
}